import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Prefecture } from 'src/models/prefecture';

@Injectable({
  providedIn: 'root'
})
export class PrefectureService {
  private prefecturesSubject: BehaviorSubject<Array<Prefecture>>;
  public prefectures$: Observable<Array<Prefecture>>;
  private cachedPrefectures: Prefecture[] | null = null;

  constructor(private http: HttpClient) {
    this.prefecturesSubject = new BehaviorSubject<Array<Prefecture>>([]);
    this.prefectures$ = this.prefecturesSubject.asObservable();
  }

  public get value(): Array<Prefecture> {
    return this.prefecturesSubject.value;
  }

  update(prefectures: Array<Prefecture>){
    this.cachedPrefectures = prefectures;
    this.prefecturesSubject.next(prefectures);
  }

  list(): Observable<Array<Prefecture>> {
    if (this.cachedPrefectures) {
      console.log('Returning cached prefectures');
      return of(this.cachedPrefectures);
    }
    return this.http.get(`${environment.apiUrl}prefectures/`).pipe(
      tap((data: Array<Prefecture>) => {
        // Mise à jour du cache
        this.cachedPrefectures = data;
        console.log('Prefectures data cached');
      }),
      shareReplay(1) // Partage la réponse entre plusieurs subscribers
    ) as Observable<Array<Prefecture>>;
  }

  getPrefecturesByRegion(pk: number): Observable<Array<Prefecture>> {
    if (this.cachedPrefectures) {
      console.log('Returning cached prefectures by region');
      return of(this.cachedPrefectures);
    }
    return this.http.post(`${environment.apiUrl}prefectures/get_prefectures_by_region/`, {region: pk})
     .pipe(
      tap((data: Array<Prefecture>) => {
        // Mise à jour du cache
        this.cachedPrefectures = data;
        console.log('Prefectures by region data cached');
      }),
      shareReplay(1) // Partage la réponse entre plusieurs subscribers
    ) as Observable<Array<Prefecture>>;
  }
}
